import { DateTime } from "luxon";

import { PersistedRecording } from "types/PersistedRecording";
import { PersistedRecordingWithPlaybackState } from "../types/PersistedRecordingWithPlaybackState";

export const getPersistedRecordingWithPlaybackState = (
    bufferStartDateTimeTicks: number,
    bufferEndDateTimeTicks: number,
    currentPlaybackTimeStamp: number,
    persistedRecording: PersistedRecording,
) => {
    const startTimeTicks = DateTime.fromISO(
        persistedRecording.persistedStartTime,
    ).valueOf();
    const stopTimeTicks = DateTime.fromISO(
        persistedRecording.persistedStopTime,
    ).valueOf();

    const inBufferWindow =
        startTimeTicks <= bufferEndDateTimeTicks &&
        stopTimeTicks >= bufferStartDateTimeTicks;

    const inPlaybackWindow =
        startTimeTicks <= currentPlaybackTimeStamp &&
        stopTimeTicks >= currentPlaybackTimeStamp;

    return {
        ...persistedRecording,
        inBufferWindow: inBufferWindow && !inPlaybackWindow,
        inPlaybackWindow,
    } as PersistedRecordingWithPlaybackState;
};
